<template>
  <!--begin::Dashboard-->
  <div class="p-5 container voluntary-page">
    <div class="mb-5 row">
      <div class="col-12 col-lg mb-2">
        <label for="" class="text-category" style="color:#9999D3"
          >ผู้ใช้งาน</label
        >
        <el-select
          size="large"
          class="w-100"
          filterable
          v-model="filterForm.recommend"
          @change="searchData"
          placeholder="ผู้ใช้งาน"
          autocomplete="one-time-code"
        >
          <el-option value="" label="ทั้งหมด"></el-option>
          <el-option value="1" label="ประชาชนทั่วไป"></el-option>
          <el-option value="2" label="นักเรียนนักศึกษา"></el-option>
          <el-option value="3" label="คณะทำงานด้านเทคนิค"></el-option>
          <el-option
            value="4"
            label="เจ้าหน้าที่ปกครองส่วนท้องถิ่น"
          ></el-option>
          <el-option value="5" label="วิศวกร"></el-option>
          <el-option value="6" label="ผู้พัฒนาโครงการ"></el-option>
          <el-option value="7" label="ผู้บริหาร/เจ้าของกิจการ"></el-option>
        </el-select>
      </div>
      <div class="col-12 col-lg mb-2">
        <label for="" class="text-category" style="color:#9999D3"
          >หมวดหมู่</label
        >
        <el-select
          size="large"
          class="w-100"
          filterable
          v-model="filterForm.category"
          @change="searchData"
          placeholder="หมวดหมู่"
          autocomplete="one-time-code"
        >
          <el-option value="" label="ทั้งหมด"></el-option>
          <el-option
            v-for="ct in categoryList"
            :key="ct.categoryCode"
            :value="ct.categoryCode"
            :label="ct.categoryName && ct.categoryName[0] && ct.categoryName[0].data"
          />
        </el-select>
      </div>
      <div class="col-12 col-lg mb-2">
        <label for="" class="text-category" style="color:#9999D3">สถานะ</label>
        <el-select
          size="large"
          class="w-100"
          filterable
          v-model="filterForm.status"
          @change="searchData"
          placeholder="สถานะ"
          autocomplete="one-time-code"
        >
          <el-option value="" label="ทั้งหมด"></el-option>
          <el-option value="-1" label="ยังไม่ได้ลงทะเบียน"></el-option>
          <el-option value="1,2" label="เรียนต่อ"></el-option>
          <!-- <el-option value="1" label="ลงทะเบียนแต่ยังไม่ได้เรียน"></el-option>
          <el-option value="2" label="เรียนต่อ"></el-option> -->
          <el-option value="3" label="จบหลักสูตร"></el-option>
          <!-- <el-option value="4" label="ไม่ผ่านหลักสูตร"></el-option> -->
          <!-- <el-option value="5" label="หมดเวลาเรียน"></el-option> -->
        </el-select>
      </div>
      <div class="col-12 col-lg mb-2">
        <label for="" class="text-category" style="color:#9999D3"
          >เรียงตาม</label
        >
        <el-select
          size="large"
          class="w-100"
          filterable
          v-model="filterForm.sortBy"
          @change="searchData"
          placeholder="เรียงตาม"
          autocomplete="one-time-code"
        >
          <el-option value="" label="ทั้งหมด"></el-option>
          <el-option value="2" label="เรียงตามตัวอักษร"></el-option>
          <el-option value="3" label="ใหม่ล่าสุด"></el-option>
          <el-option value="4" label="ยอดนิยม"></el-option>
          <el-option value="1" label="แนะนำ"></el-option>
        </el-select>
      </div>
      <div class="col-12 col-lg mb-2">
        <label for="" class="text-category" style="color:#9999D3">ค้นหา</label>
        <input
          class="form-control"
          type="text"
          v-model="filterForm.search"
          @change="searchData"
          autocomplete="one-time-code"
          style="height:40px"
          placeholder="ค้นหา"
        />
      </div>
    </div>
    <div class="row mb-5" v-if="listData && listData.length > 0">
      <div
        class="col-12 col-md-6 col-lg-4 mb-5 d-flex"
        style="padding: 10px;"
        v-for="(item, index) in listData"
        :key="index"
      >
        <router-link :to="'/course/voluntary/' + item.id" class="w-100 d-flex">
          <div
            class="card box-item d-flex flex-column w-100"
            style="border-radius: 10px;position: relative;border: 1px solid #E9E9EF;"
          >
            <div style="position: relative;">
              <img
                :src="imageUrl + item.thumbnailsPath"
                @error="setAltImg"
                alt=""
                class="w-100"
                style="border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            height: 220px;
            object-fit: cover;"
              />
              <div
                style="position: absolute;left: 10px;bottom: 10px;display: flex;flex-direction: row;
                    flex-wrap: nowrap;
                    overflow-x: hidden;"
              >
                <div
                  style="margin-right:5px"
                  v-for="(itemHas, index) in item.hashtag"
                  :key="index"
                >
                  <span class="badge badge-danger">{{ itemHas }}</span>
                </div>
              </div>
            </div>

            <div
              class="card-body responsive-body flex-grow-1"
              style="min-height: 153px"
            >
              <div
                class="mb-5 limit-text text-title"
                style="font-weight: 400;
                color: #323563;"
              >
                {{ item.title }}
              </div>
              <Rating :value="item.rate ? item.rate : 0" :max="5" />
              <!-- <div class="text-category" style="color:#9999D3">
                  หมวดหมู่ :
                  <span v-html="renderCategory(item.categoryProfile)"></span>
                </div> -->
              <!-- <div
                class="mb-5 limit-text text-info"
                style="font-weight: 400;
                color: #9F9F9F!important;"
                v-html="removeStyle(item.description)"
              ></div> -->
            </div>
            <div class="card-footer mt-auto">
              <div
                class="d-flex align-items-center flex-column mt-3 w-100"
                v-if="item.register == true && item.progressUpdate != 100"
              >
                <div
                  class="d-flex justify-content-between fw-bold fs-6 text-dark w-100 mt-auto mb-2"
                >
                  <span style="font-weight: 600;"
                    >สถานะ :
                    <span v-html="renderStatus(item.statusRegister)"></span
                  ></span>
                  <span>{{ item.progressUpdate }}%</span>
                </div>
                <div
                  class="h-8px mx-3 w-100 rounded"
                  style="background:#E1F2FF"
                >
                  <div
                    class="bg-progressbar rounded h-8px"
                    data-bs-toggle="tooltip"
                    :title="item.progressUpdate + '%'"
                    role="progressbar"
                    :style="'width: ' + item.progressUpdate + '%'"
                    aria-valuenow="50"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
              <div v-else style="display: flex;justify-content: center;">
                <a
                  href="#"
                  v-if="item.register == true && item.progressUpdate == 100"
                  class="btn text-btn"
                  data-bs-toggle="modal"
                  data-bs-target="#kt_modal_cert"
                  @click="getCertificateId(item.id)"
                  style="border-radius: 21px;background: #31B67C;color: #FFF;min-width: 235px;"
                  :style="!item.flgCertEnable ? 'border-radius: 21px;background: #E1E1E1;color: #999;min-width: 235px;pointer-events: none;' : 'border-radius: 21px;background: #31B67C;color: #FFF;min-width: 235px;'"
                  >ดาวน์โหลดใบรับรอง </a
                >
                <router-link
                  v-else
                  :to="'/course/voluntary/' + item.id"
                  type="button"
                  class="btn btn-register2 text-btn"
                >
                  ลงทะเบียน
                </router-link>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class=" row mb-5" v-else>
      <img src="media/image-app/no-data.svg" alt="" style="height:300px" />
    </div>
    <div
      v-if="listData && listData.length > 0"
      class="d-flex justify-content-between align-items-center flex-wrap"
    >
      <b class="text-category" style="color:#9999D3"
        >จำนวน {{ listData && listData.totalElements }} รายการ</b
      >
      <ul class="pagination">
        <li :class="'page-item previous ' + (page == 0 ? 'disabled' : '')">
          <button type="button" @click="backPage()" class="page-link">
            <i class="previous"></i>
          </button>
        </li>
        <div v-for="(item, index) in totalPage" :key="index">
          <li :class="'page-item ' + (index == page ? 'active' : '')">
            <button type="button" @click="changePage(item)" class="page-link">
              {{ item }}
            </button>
          </li>
        </div>
        <li
          :class="'page-item next ' + (page + 1 == totalPage ? 'disabled' : '')"
        >
          <button type="button" @click="nextPage()" class="page-link">
            <i class="next"></i>
          </button>
        </li>
      </ul>
    </div>
  </div>
  <!-- <div class="modal fade" tabindex="-1" id="kt_modal_cert">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-body">
          <div style="text-align:center;" v-if="listCertificate">
            <div>
              <img src="media/image-app/image 10.svg" alt="" class="w-50" />
            </div>
            <div>
              <p class="text-title my-10">ขอมอบใบรับรองนี้ให้แก่</p>
              <p class="text-title my-20">
                {{ listCertificate.authorProfile.prefix }}
                {{ listCertificate.authorProfile.firstName }}
                {{ listCertificate.authorProfile.lastName }}
              </p>
              <p class="text-title my-10">
                เพื่อแสดงว่าได้ผ่านการฝึกอบรมออนไลน์หลักสูตร
              </p>
              <p class="text-title my-10">
                {{ listCertificate.courseProfile.title }}
              </p>
              <p class="text-title my-10">
                ให้ไว้ ณ วันที่
                {{ formatDate(listCertificate.certApproveDate) }}
              </p>
              <p class="text-title" style="margin-top:15vh">
                (นางมัณลิกา สมพรานนท์)
              </p>
              <p class="text-title my-10">
                ผู้อำนวยการกองพัฒนาทรัพยากรบุคคลด้านพลังงาน ปฏิบัติราชการแทน
              </p>
              <p class="text-title my-10">
                อธิบดีกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            ปิด
          </button>
          <button
            type="button"
            class="btn "
            style="border-radius: 21px;background: #31B67C;color: #FFF;"
            @click="downloadCertificate"
          >
            ดาวน์โหลดใบรับรอง
          </button>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Survey Dialog -->
  <el-dialog
    v-model="dialogSurvey"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    title="แบบสอบถามความพึงพอใจการใช้งานระบบ"
    class="w-100"
    width="450px"
  >
    <div style="max-height: 500px; overflow: auto; padding: 0 10px;">
      <div class="mb-4">
        <p style="font-weight: 600; font-size: 14px;">
          1. ระบบ e-Learning ใช้งานง่ายและเข้าใจได้ชัดเจนเพียงใด
        </p>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <label
            v-for="(opt, idx) in surveyOptions"
            :key="'q1-' + idx"
            style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
          >
            <span style="font-size: 28px;">{{ opt.emoji }}</span>
            <span style="font-size: 11px; color: #666;">{{ opt.label }}</span>
            <input type="radio" :value="opt.value" v-model="surveyData.q1" style="margin-top: 4px;" />
          </label>
        </div>
      </div>
      <div class="mb-4">
        <p style="font-weight: 600; font-size: 14px;">
          2. ความสะดวกและความรวดเร็วในการเข้าใช้งานระบบ
        </p>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <label
            v-for="(opt, idx) in surveyOptions"
            :key="'q2-' + idx"
            style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
          >
            <span style="font-size: 28px;">{{ opt.emoji }}</span>
            <span style="font-size: 11px; color: #666;">{{ opt.label }}</span>
            <input type="radio" :value="opt.value" v-model="surveyData.q2" style="margin-top: 4px;" />
          </label>
        </div>
      </div>
      <div class="mb-4">
        <p style="font-weight: 600; font-size: 14px;">
          3. คุณภาพของเนื้อหา/บทเรียนตรงกับความต้องการในการเรียนรู้
        </p>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <label
            v-for="(opt, idx) in surveyOptions"
            :key="'q3-' + idx"
            style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
          >
            <span style="font-size: 28px;">{{ opt.emoji }}</span>
            <span style="font-size: 11px; color: #666;">{{ opt.label }}</span>
            <input type="radio" :value="opt.value" v-model="surveyData.q3" style="margin-top: 4px;" />
          </label>
        </div>
      </div>
      <div class="mb-4">
        <p style="font-weight: 600; font-size: 14px;">
          4. ความเสถียรของระบบ (ไม่ค้าง ไม่หลุด ระหว่างใช้งาน)
        </p>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <label
            v-for="(opt, idx) in surveyOptions"
            :key="'q4-' + idx"
            style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
          >
            <span style="font-size: 28px;">{{ opt.emoji }}</span>
            <span style="font-size: 11px; color: #666;">{{ opt.label }}</span>
            <input type="radio" :value="opt.value" v-model="surveyData.q4" style="margin-top: 4px;" />
          </label>
        </div>
      </div>
      <div class="mb-4">
        <p style="font-weight: 600; font-size: 14px;">
          5. ภาพรวมความพึงพอใจต่อการใช้งานระบบ e-Learning
        </p>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <label
            v-for="(opt, idx) in surveyOptions"
            :key="'q5-' + idx"
            style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
          >
            <span style="font-size: 28px;">{{ opt.emoji }}</span>
            <span style="font-size: 11px; color: #666;">{{ opt.label }}</span>
            <input type="radio" :value="opt.value" v-model="surveyData.q5" style="margin-top: 4px;" />
          </label>
        </div>
      </div>
      <div class="mb-3">
        <p style="font-weight: 600; font-size: 14px;">6. ข้อเสนอแนะ</p>
        <textarea
          v-model="surveyData.suggestion"
          class="form-control"
          rows="3"
          placeholder="กรอก"
          maxlength="150"
          style="border-radius: 10px;"
        ></textarea>
        <div style="text-align: right; font-size: 12px; color: #999; margin-top: 4px;">
          {{ (surveyData.suggestion || '').length }}/150
        </div>
      </div>
    </div>
    <template #footer>
      <div style="display: flex; justify-content: center;">
        <button
          class="btn px-8"
          type="button"
          style="border-radius: 21px; background: #323563; color: #FFF;"
          @click="submitSurvey"
        >
          ส่งแบบสอบถาม
        </button>
        <button
          class="btn px-8"
           type="button"
           style="border-radius: 21px; background: #e5e7eb; color: #000; margin-left: 10px;"
           @click="dialogSurvey = false"
         >
           ข้ามไปก่อน
         </button>
      </div>
    </template>
  </el-dialog>
</template>
<script lang="ts">
import { defineComponent, nextTick, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Rating from "../Rating.vue";
import axios from "axios";
import { useRoute } from "vue-router";
const video = ref();
const canvas = ref();
const captures = ref({});
const isCameraOpen = ref(false);
const listData = ref();
const limit = ref(6);
const page = ref(0);
const orderBy = ref(1);
const categories = ref([]);
const totalPage = ref(0);
const listCertificate = ref();
const dialogSurvey = ref(false);
const surveyCourseId = ref(null);
const surveyOptions = ref([
  { emoji: "😆", label: "มากที่สุด", value: 5 },
  { emoji: "😊", label: "มาก", value: 4 },
  { emoji: "😐", label: "ปานกลาง", value: 3 },
  { emoji: "😞", label: "น้อย", value: 2 },
  { emoji: "😢", label: "น้อยที่สุด", value: 1 },
]);
const surveyData = ref({
  q1: null,
  q2: null,
  q3: null,
  q4: null,
  q5: null,
  suggestion: "",
});
const filterForm = ref({
  recommend: "",
  category: "",
  status: "",
  sortBy: "3",
  search: "",
  hashtag: "",
});
export default defineComponent({
  name: "voluntary",
  components: {
    Rating,
  },
  data() {
    return {
      categoryList: [],
      imageUrl: process.env.VUE_APP_IMG_URL,
    };
  },
  setup() {
    /* eslint-disable */
    const route = useRoute();
    onMounted(() => {
      if (route.query.recommend) {
        filterForm.value.recommend = route.query.recommend + "";
      }
      if (route.query.hashtag) {
        filterForm.value.hashtag = route.query.hashtag + "";
      }
      getDataList();
    });
    watch(
      () => route.path,
      () => {
        nextTick(() => {
          if (route.query.recommend) {
            filterForm.value.recommend = route.query.recommend + "";
          }
          if (route.query.hashtag) {
            filterForm.value.hashtag = route.query.hashtag + "";
          }
          getDataList();
        });
      },
    );
    const getDataList = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getCourse?sizeContents=" +
            limit.value +
            "&page=" +
            page.value +
            "&orderBy=" +
            orderBy.value +
            "&sort=" +
            filterForm.value.sortBy +
            "&category=" +
            filterForm.value.category +
            "&registerStatus=" +
            filterForm.value.status +
            "&keyWord=" +
            filterForm.value.search +
            "&recommend=" +
            filterForm.value.recommend +
            "&hashtag=" +
            filterForm.value.hashtag +
            "&flgGeneral=1",
          {
            headers: {
              token: localStorage.getItem("id_token")
                ? localStorage.getItem("id_token")
                : localStorage.getItem("tokenGuest"),
            },
          },
        )
        .then((response) => {
          // console.log(response);
          listData.value = response.data.data.content;
          listData.value["totalElements"] = response.data.data.totalElements;
          totalPage.value = response.data.data.totalPages;
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const changePage = (pageEvent) => {
      // console.log(pageEvent);
      page.value = pageEvent - 1;
      getDataList();
    };
    const backPage = () => {
      page.value = page.value - 1;
      getDataList();
    };
    const nextPage = () => {
      page.value = page.value + 1;
      getDataList();
    };
    const searchData = () => {
      getDataList();
    };
    const getCertificateId = async (id) => {
      // เปิดหน้าต่างทันทีขณะยังอยู่ใน user gesture ป้องกัน popup blocker บน iOS Safari
      const certWindow = window.open("", "_blank");
      let checkSurvey = await axios.get(
        process.env.VUE_APP_API_URL + "/checkCertApproveSurvey",
        {
          headers: { token: localStorage.getItem("id_token") },
        },
      );
      if (checkSurvey.data.code == 400) {
        if (certWindow) certWindow.close();
        dialogSurvey.value = true;
        surveyCourseId.value = id;
        surveyData.value = {
          q1: null,
          q2: null,
          q3: null,
          q4: null,
          q5: null,
          suggestion: "",
        };
      } else {
        proceedDownloadCertificate(id, certWindow);
      }
    };
    const proceedDownloadCertificate = async (id, certWindow: any = null) => {
      const certificate = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getCourseRegister?courseId=" +
          id +
          "&userId=" +
          localStorage.getItem("u_id"),
        {
          headers: { token: localStorage.getItem("id_token") },
        },
      );
      listCertificate.value = certificate.data.data.content[0];
      downloadCertificate(listCertificate.value.id, certWindow);
    };
    const submitSurvey = async () => {
      // เปิดหน้าต่างทันทีขณะยังอยู่ใน user gesture ป้องกัน popup blocker บน iOS Safari
      const certWindow = window.open("", "_blank");
      let fromData = new FormData();
      fromData.append("q1", surveyData.value.q1 + "");
      fromData.append("q2", surveyData.value.q2 + "");
      fromData.append("q3", surveyData.value.q3 + "");
      fromData.append("q4", surveyData.value.q4 + "");
      fromData.append("q5", surveyData.value.q5 + "");
      fromData.append("q6", surveyData.value.suggestion);
      await axios.post(
        process.env.VUE_APP_API_URL + "/addEditCertApproveSurvey",
        fromData,
        {
          headers: {
            token: localStorage.getItem("id_token"),
            "Content-Type": "multipart/form-data",
          },
        },
      );
      dialogSurvey.value = false;
      proceedDownloadCertificate(surveyCourseId.value, certWindow);
    };
  const downloadCertificate = async (id, certWindow: any = null) => {
      if (!certWindow) {
        certWindow = window.open("", "_blank");
      }
      Swal.fire({
        title: "กำลังดาวน์โหลดใบประกาศนียบัตร",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/downloadCertificateCourse?courseRegisterId=" +
            id,
          {
            headers: { token: localStorage.getItem("id_token") },
            responseType: "blob", // กำหนดให้รับข้อมูลเป็น Blob
          },
        )
        .then(async (res) => {
          console.log(res);
          
          if (res.data) {
            const contentDisposition = res.headers["content-disposition"];
            const fileName = contentDisposition
              ? contentDisposition.split("filename=")[1]
              : "certificate.pdf";

            // ตรวจสอบเนื้อหาในกรณีเกิดข้อผิดพลาด
            if (res.data.type === "application/json") {
              const text = await res.data.text();
              const errorData = JSON.parse(text);
              console.error("Error downloading PDF:", errorData.message);
              if (certWindow) certWindow.close();
              Swal.fire({
                title: "ดาวน์โหลดไฟล์ไม่สำเร็จ",
                text: "กรุณาลองใหม่อีกครั้ง",
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "ตกลง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-primary",
                },
              });
              return;
            }

            // สร้าง Blob URL แล้วนำหน้าต่างที่เปิดไว้ตั้งแต่ตอน user gesture ไปที่ URL นั้น
            const url = window.URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" }),
            );
            if (certWindow) {
              certWindow.location.href = url;
            } else {
              window.open(url, "_blank");
            }
            Swal.close();
          } else {
            if (certWindow) certWindow.close();
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          if (certWindow) certWindow.close();
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const arabic_to_thai = (text) => {
      let data = text
        .replaceAll("1", "๑")
        .replaceAll("2", "๒")
        .replaceAll("3", "๓")
        .replaceAll("4", "๔")
        .replaceAll("5", "๕")
        .replaceAll("6", "๖")
        .replaceAll("7", "๗")
        .replaceAll("8", "๘")
        .replaceAll("9", "๙")
        .replaceAll("0", "๐");
      return data;
    };
    return {
      video,
      canvas,
      captures,
      isCameraOpen,
      getDataList,
      changePage,
      backPage,
      nextPage,
      listData,
      limit,
      page,
      orderBy,
      categories,
      totalPage,
      filterForm,
      searchData,
      getCertificateId,
      downloadCertificate,
      listCertificate,
      arabic_to_thai,
      dialogSurvey,
      surveyCourseId,
      surveyOptions,
      surveyData,
      submitSurvey,
    };
  },
  methods: {
    formatDate(date) {
      const event = new Date(date);
      let dateString =
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }) + "";
      return dateString;
    },
    removeStyle(html) {
      const regex = /(style=".+?")/gm;
      const str = html;
      const subst = ``;
      const result = str.replace(regex, subst);
      return result;
    },
    setAltImg(event) {
      event.target.src = "media/image-app/no-image.svg";
    },
    /* eslint-disable */
    renderCategory(list) {
      let data: any = [];
      for (const looplist of list) {
        data.push(looplist[0].data);
      }
      if (data.length > 0) {
        return data.join(",");
      } else {
        return "-";
      }
    },
    renderStatus(status) {
      if (status == 1 || status == 2) {
        return "<span style='color:#9999D3'>เรียนต่อ</span>";
      } else if (status == 3) {
        return "<span style='color:#31B67C'>เรียนจบ</span>";
      } else if (status == 4) {
        return "<span style='color:#FF7786'>ไม่ผ่านหลักสูตร</span>";
      } else if (status == 5) {
        return "<span style='color:#F2A17D'>หมดเวลาเรียน</span>";
      } else {
        return "-";
      }
    },
  },
  async mounted() {
    try {
      const category = await axios.get(
        process.env.VUE_APP_API_URL + "/category?categoryType=course",
        {
          headers: {
            token: localStorage.getItem("id_token")
              ? localStorage.getItem("id_token")
              : localStorage.getItem("tokenGuest"),
          },
        },
      );
      this.categoryList = category.data?.data;
    } catch (error) {
      // console.log(error);
    }
  },
});
</script>
<style lang="scss">
.voluntary-page .el-input__inner {
  background: #ffffff !important;
  box-shadow: none !important;
  border-radius: 10px !important;
}
.voluntary-page .el-input__inner:hover,
.voluntary-page .el-input__inner.is-focus {
  box-shadow: none !important;
}
.voluntary-page input.form-control {
  background: #ffffff !important;
  box-shadow: none !important;
  border-radius: 10px !important;
}
</style>
